import React, {PropsWithChildren} from "react";

import * as S from './styles'

type SliderItemProps = {
    activeIndex?: number
    rowNumber?: number
}

type SliderProps = {
    children?: JSX.Element[]
    activeIndex: number
    setActive: Function
}

const Slider = ({children, activeIndex, setActive}: SliderProps) => {
    const items = React.Children.map(children, (child, idx) => {
        if (React.isValidElement(child)) {
            const props = {activeIndex: activeIndex, rowNumber: idx, onClick: () => setActive(idx)};
            return React.cloneElement(child, props);
        }
        return child;
    });

    return (
        <S.Slider>{items}</S.Slider>
    )
}

const Item = (props: PropsWithChildren<SliderItemProps>) => {
    const items = React.Children.map(props.children, (child, idx) => {
        if (React.isValidElement(child)) {
            const p = {isActive: props.activeIndex === props.rowNumber};
            return React.cloneElement(child, p);
        }
        return child;
    });

    return <S.SliderItem {...props}>{items}</S.SliderItem>
}

export default Object.assign(Slider, {Item})